import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { HomeComponent } from './home/home.component';
import { CadastroClienteComponent } from './cliente/cadastro-cliente/cadastro-cliente.component';
import { CadastroUsuarioComponent } from './usuario/cadastro-usuario/cadastro-usuario.component';
import { ListarClientesComponent } from './cliente/listar-clientes/listar-clientes.component';
import { SelecaoClientesComponent } from './cliente/selecao-clientes/selecao-clientes.component';
import { ListarUsuariosComponent } from './usuario/listar-usuarios/listar-usuarios.component';
import { ListarPontoFisicoComponent } from './ponto-fisico/listar-ponto-fisico/listar-ponto-fisico.component';
import { CadastroSetorComponent } from './setor/cadastro-setor/cadastro-setor.component';
import { CadastroProcessoComponent } from './processo/cadastro-processo/cadastro-processo.component';
import { UserLoginComponent } from './auth/user-login/user-login.component';
import { AuthGuard } from './auth/auth-guard.service';
import { PesquisaResultadoColetaComponent } from './coleta/pesquisa-resultado-coleta/pesquisa-resultado-coleta.component';
import { ResultadoColetaComponent } from './coleta/resultado-coleta/resultado-coleta.component';
import { CadastroDadoTransacionalComponent } from './construcao-variaveis/cadastro-dado-transacional/cadastro-dado-transacional.component';
// tslint:disable-next-line:max-line-length
import { ConstrucaoVariaveisTabsetComponent } from './construcao-variaveis/construcao-variaveis-tabset/construcao-variaveis-tabset.component';
import { ConstrucaoVariavelComponent } from './construcao-variaveis/construcao-variavel/construcao-variavel.component';
import { ListarDadosTransacionaisComponent } from './construcao-variaveis/listar-dados-transacionais/listar-dados-transacionais.component';
import { ListarVariaveisComponent } from './construcao-variaveis/listar-variaveis/listar-variaveis.component';
import { CadastroIndicadorComponent } from './indicador/cadastro-indicador/cadastro-indicador.component';
import { ListarIndicadoresComponent } from './indicador/listar-indicadores/listar-indicadores.component';
// tslint:disable-next-line:max-line-length
import { CadastroAgendamentoOcorrenciaComponent } from './ocorrencias/cadastro-agendamento-ocorrencia/cadastro-agendamento-ocorrencia.component';
import { CadastroOcorrenciaComponent } from './ocorrencias/cadastro-ocorrencia/cadastro-ocorrencia.component';
import { DetalheOcorrenciaComponent } from './ocorrencias/detalhe-ocorrencia/detalhe-ocorrencia.component';
import { ListarAgendamentoOcorrenciaComponent } from './ocorrencias/listar-agendamento-ocorrencia/listar-agendamento-ocorrencia.component';
import { CadastroRegiaoComponent } from './regiao/cadastro-regiao/cadastro-regiao.component';
import { CadastroGrupoAcessoComponent } from './permissoes-acesso/cadastro-grupo-acesso/cadastro-grupo-acesso.component';
// tslint:disable-next-line:max-line-length
import { CadastroUsuarioGrupoAcessoComponent } from './permissoes-acesso/cadastro-usuario-grupo-acesso/cadastro-usuario-grupo-acesso.component';
import { ListarGrupoAcessoComponent } from './permissoes-acesso/listar-grupo-acesso/listar-grupo-acesso.component';
import { ListarUsuarioGrupoAcessoComponent } from './permissoes-acesso/listar-usuario-grupo-acesso/listar-usuario-grupo-acesso.component';
import { CadastroPontoFisicoComponent } from './ponto-fisico/cadastro-ponto-fisico/cadastro-ponto-fisico.component';
import { ProcessoTabsetComponent } from './processo/processo-tabset/processo-tabset.component';
import { ListarRegioesComponent } from './regiao/listar-regioes/listar-regioes.component';
import { CadastroRoteiroComponent } from './roteiro/cadastro-roteiro/cadastro-roteiro.component';
import { ListarRoteiroComponent } from './roteiro/listar-roteiro/listar-roteiro.component';
import { ListarRoteirosUsuarioComponent } from './roteiro/listar-roteiros-usuario/listar-roteiros-usuario.component';
import { VisaoRoteirosAtivosComponent } from './roteiro/visao-roteiros-ativos/visao-roteiros-ativos.component';
import { CadastroRotinaComponent } from './rotina/cadastro-rotina/cadastro-rotina.component';
import { ListarRotinasClienteComponent } from './rotina/listar-rotinas-cliente/listar-rotinas-cliente.component';
import { RotinaTabsetComponent } from './rotina/rotina-tabset/rotina-tabset.component';
import { CadastroDashboardComponent } from './dashboards/cadastro-dashboard/cadastro-dashboard.component';
import { VisualizarDashboardComponent } from './dashboards/visualizar-dashboard/visualizar-dashboard.component';
import { ListarDashboardsComponent } from './dashboards/listar-dashboards/listar-dashboards.component';
import { VisaoGeralOcorrenciasComponent } from './ocorrencias/visao-geral-ocorrencias/visao-geral-ocorrencias.component';
import { SetorTabsetComponent } from './setor/setor-tabset/setor-tabset.component';
import { PermissoesTabsetComponent } from './permissoes-acesso/permissoes-tabset/permissoes-tabset.component';
import { ListarOcorrenciasComponent } from './ocorrencias/listar-ocorrencias/listar-ocorrencias.component';
import { PesquisaInconsistenciasComponent } from './coleta/pesquisa-inconsistencias/pesquisa-inconsistencias.component';
import { ResultadoInconsistenciasComponent } from './coleta/resultado-inconsistencias/resultado-inconsistencias.component';
import { ListarOcorrenciasGraficoComponent } from './ocorrencias/listar-ocorrencias-grafico/listar-ocorrencias-grafico.component';
import { PesquisaReincidenciaComponent } from './rotina/pesquisa-reincidencia/pesquisa-reincidencia.component';
import { ListaReincidenciasComponent } from './rotina/lista-reincidencias/lista-reincidencias.component';
import { ListarRoteiroInternoComponent } from './roteiro/listar-roteiro-interno/listar-roteiro-interno.component';
import { RoteiroInternoComponent } from './roteiro/roteiro-interno/roteiro-interno.component';

export interface Rota {

    readonly path: string;
    readonly displayFront: string;
}

export const APP_ROUTES: Routes = [

    {
        path: '',
        canActivate: [AuthGuard], data: {
            roles: ['PUBLIC']
        }, component: HomeComponent
    },
    {
        path: 'login',
        component: UserLoginComponent
    },
    {
        path: 'listar-usuarios',
        canActivate: [AuthGuard], data: {
            roles: ['USUARIOS_VISUALIZAR', 'USUARIOS_ALTERAR']
        }, component: ListarUsuariosComponent
    },
    {
        path: 'cadastrar-usuario',
        canActivate: [AuthGuard], data: {
            roles: ['USUARIOS_ALTERAR']
        }, component: CadastroUsuarioComponent
    },
    {
        path: 'atualizar-usuario/:id',
        canActivate: [AuthGuard], data: {
            roles: ['USUARIOS_VISUALIZAR', 'USUARIOS_ALTERAR']
        }, component: CadastroUsuarioComponent
    },
    {
        path: 'listar-clientes',
        canActivate: [AuthGuard], data: {
            roles: ['CLIENTES_VISUALIZAR', 'CLIENTES_ALTERAR', 'ADMIN']
        }, component: ListarClientesComponent
    },
    {
        path: 'selecao-clientes',
        canActivate: [AuthGuard], data: {
            roles: ['ADMIN']
        }, component: SelecaoClientesComponent
    },
    {
        path: 'cadastrar-cliente',
        canActivate: [AuthGuard], data: {
            roles: ['ADMIN']
        }, component: CadastroClienteComponent
    },
    {
        path: 'atualizar-cliente/:id',
        canActivate: [AuthGuard], data: {
            roles: ['CLIENTES_VISUALIZAR', 'CLIENTES_ALTERAR']
        }, component: CadastroClienteComponent
    },
    {
        path: 'cadastro-setor',
        canActivate: [AuthGuard], data: {
            roles: ['SETOR_ALTERAR']
        }, component: CadastroSetorComponent
    },
    {
        path: 'atualizar-setor/:id',
        canActivate: [AuthGuard], data: {
            roles: ['SETOR_VISUALIZAR', 'SETOR_ALTERAR']
        }, component: CadastroSetorComponent
    },
    {
        path: 'listar-setores',
        canActivate: [AuthGuard], data: {
            roles: ['SETOR_VISUALIZAR', 'SETOR_ALTERAR']
        }, component: SetorTabsetComponent
    },
    {
        path: 'listar-ponto-fisico',
        canActivate: [AuthGuard], data: {
            roles: ['PONTO_FISICO_VISUALIZAR', 'PONTO_FISICO_ALTERAR']
        }, component: ListarPontoFisicoComponent
    },
    {
        path: 'cadastro-ponto-fisico',
        canActivate: [AuthGuard], data: {
            roles: ['PONTO_FISICO_ALTERAR']
        }, component: CadastroPontoFisicoComponent
    },
    {
        path: 'atualizar-ponto-fisico/:id',
        canActivate: [AuthGuard], data: {
            roles: ['PONTO_FISICO_VISUALIZAR', 'PONTO_FISICO_ALTERAR']
        }, component: CadastroPontoFisicoComponent
    },
    {
        path: 'listar-processos',
        canActivate: [AuthGuard], data: {
            roles: ['PROCESSO_VISUALIZAR', 'PROCESSO_ALTERAR']
        }, component: ProcessoTabsetComponent
    },
    {
        path: 'cadastro-processo',
        canActivate: [AuthGuard], data: {
            roles: ['PROCESSO_ALTERAR']
        }, component: CadastroProcessoComponent
    },
    {
        path: 'atualizar-processo/:id',
        canActivate: [AuthGuard], data: {
            roles: ['PROCESSO_VISUALIZAR', 'PROCESSO_ALTERAR']
        }, component: CadastroProcessoComponent
    },
    {
        path: 'rotinas',
        canActivate: [AuthGuard], data: {
            roles: ['CHECKLIST_VISUALIZAR', 'CHECKLIST_ALTERAR']
        }, component: RotinaTabsetComponent
    },
    {
        path: 'listar-rotinas-cliente',
        canActivate: [AuthGuard], data: {
            roles: ['CHECKLIST_VISUALIZAR', 'CHECKLIST_ALTERAR']
        }, component: ListarRotinasClienteComponent
    },
    {
        path: 'cadastro-rotina',
        canActivate: [AuthGuard], data: {
            roles: ['CHECKLIST_ALTERAR']
        }, component: CadastroRotinaComponent
    },
    {
        path: 'atualizar-rotina/:id',
        canActivate: [AuthGuard], data: {
            roles: ['CHECKLIST_VISUALIZAR', 'CHECKLIST_ALTERAR']
        }, component: CadastroRotinaComponent
    },
    {
        path: 'listar-roteiros',
        canActivate: [AuthGuard], data: {
            roles: ['ROTEIRO_VISUALIZAR', 'ROTEIRO_ALTERAR']
        }, component: ListarRoteiroComponent
    },
    {
        path: 'cadastro-roteiro',
        canActivate: [AuthGuard], data: {
            roles: ['ROTEIRO_ALTERAR']
        }, component: CadastroRoteiroComponent
    },
    {
        path: 'atualizar-roteiro/:id',
        canActivate: [AuthGuard], data: {
            roles: ['ROTEIRO_VISUALIZAR', 'ROTEIRO_ALTERAR']
        }, component: CadastroRoteiroComponent
    },
    {
        path: 'visao-roteiros-ativos',
        canActivate: [AuthGuard], data: {
            roles: ['ROTEIRO_VISUALIZAR', 'ROTEIRO_ALTERAR']
        }, component: VisaoRoteirosAtivosComponent
    },
    {
        path: 'listar-roteiros-usuario/:id',
        canActivate: [AuthGuard], data: {
            roles: ['ROTEIRO_VISUALIZAR', 'ROTEIRO_ALTERAR']
        }, component: ListarRoteirosUsuarioComponent
    },
    {
        path: 'permissoes',
        canActivate: [AuthGuard], data: {
            roles: ['PERMISSAO_VISUALIZAR', 'PERMISSAO_ALTERAR']
        }, component: PermissoesTabsetComponent
    },
    {
        path: 'listar-grupos-acesso',
        canActivate: [AuthGuard], data: {
            roles: ['PERMISSAO_VISUALIZAR', 'PERMISSAO_ALTERAR']
        }, component: ListarGrupoAcessoComponent
    },
    {
        path: 'cadastro-grupo-acesso',
        canActivate: [AuthGuard], data: {
            roles: ['PERMISSAO_ALTERAR']
        }, component: CadastroGrupoAcessoComponent
    },
    {
        path: 'atualizar-grupo-acesso/:id',
        canActivate: [AuthGuard], data: {
            roles: ['PERMISSAO_VISUALIZAR', 'PERMISSAO_ALTERAR']
        }, component: CadastroGrupoAcessoComponent
    },
    {
        path: 'listar-usuarios-grupos-acesso',
        canActivate: [AuthGuard], data: {
            roles: ['PERMISSAO_VISUALIZAR', 'PERMISSAO_ALTERAR']
        }, component: ListarUsuarioGrupoAcessoComponent
    },
    {
        path: 'cadastro-usuario-grupo-acesso',
        canActivate: [AuthGuard], data: {
            roles: ['PERMISSAO_ALTERAR']
        }, component: CadastroUsuarioGrupoAcessoComponent
    },
    {
        path: 'atualizar-usuario-grupo-acesso/:id',
        canActivate: [AuthGuard], data: {
            roles: ['PERMISSAO_VISUALIZAR', 'PERMISSAO_ALTERAR']
        }, component: CadastroUsuarioGrupoAcessoComponent
    },
    {
        path: 'listar-regioes',
        canActivate: [AuthGuard], data: {
            roles: ['REGIAO_VISUALIZAR', 'REGIAO_ALTERAR']
        }, component: ListarRegioesComponent
    },
    {
        path: 'cadastro-regiao',
        canActivate: [AuthGuard], data: {
            roles: ['REGIAO_ALTERAR']
        }, component: CadastroRegiaoComponent
    },
    {
        path: 'atualizar-regiao/:id',
        canActivate: [AuthGuard], data: {
            roles: ['REGIAO_VISUALIZAR', 'REGIAO_ALTERAR']
        }, component: CadastroRegiaoComponent
    },
    {
        path: 'listar-agendamento-ocorrencias',
        canActivate: [AuthGuard], data: {
            roles: ['OCORRENCIA_AUTOMATICA_VISUALIZAR', 'OCORRENCIA_AUTOMATICA_ALTERAR']
        }, component: ListarAgendamentoOcorrenciaComponent
    },
    {
        path: 'listar-ocorrencias',
        canActivate: [AuthGuard], data: {
            roles: ['BAIXA_OCORRENCIAS_VISUALIZAR', 'BAIXA_OCORRENCIAS_ALTERAR']
        }, component: ListarOcorrenciasComponent
    },
    {
        path: 'listar-ocorrencias-grafico/:origem',
        canActivate: [AuthGuard], data: {
            roles: ['CONTROLE_OCORRENCIAS_VISUALIZAR', 'CONTROLE_OCORRENCIAS_ALTERAR']
        }, component: ListarOcorrenciasGraficoComponent
    },
    {
        path: 'cadastro-agendamento-ocorrencia',
        canActivate: [AuthGuard], data: {
            roles: ['OCORRENCIA_AUTOMATICA_ALTERAR']
        }, component: CadastroAgendamentoOcorrenciaComponent
    },
    {
        path: 'atualizar-agendamento-ocorrencia/:id',
        canActivate: [AuthGuard], data: {
            roles: ['OCORRENCIA_AUTOMATICA_VISUALIZAR', 'OCORRENCIA_AUTOMATICA_ALTERAR']
        }, component: CadastroAgendamentoOcorrenciaComponent
    },
    {
        path: 'cadastro-ocorrencia',
        canActivate: [AuthGuard], data: {
            roles: ['OCORRENCIA_MANUAL_ALTERAR']
        }, component: CadastroOcorrenciaComponent
    },
    {
        path: 'visao-geral-ocorrencias',
        canActivate: [AuthGuard], data: {
            roles: ['CONTROLE_OCORRENCIAS_VISUALIZAR', 'CONTROLE_OCORRENCIAS_ALTERAR']
        }, component: VisaoGeralOcorrenciasComponent
    },
    {
        path: 'detalhe-ocorrencia/:id/:origem',
        canActivate: [AuthGuard], data: {
            roles: ['BAIXA_OCORRENCIAS_VISUALIZAR', 'BAIXA_OCORRENCIAS_ALTERAR',
                'CONTROLE_OCORRENCIAS_VISUALIZAR', 'CONTROLE_OCORRENCIAS_ALTERAR']
        }, component: DetalheOcorrenciaComponent
    },
    {
        path: 'listar-indicadores',
        canActivate: [AuthGuard], data: {
            roles: ['INDICADORES_OPERACIONAIS_VISUALIZAR', 'INDICADORES_OPERACIONAIS_ALTERAR']
        }, component: ListarIndicadoresComponent
    },
    {
        path: 'cadastro-indicador',
        canActivate: [AuthGuard], data: {
            roles: ['INDICADORES_OPERACIONAIS_ALTERAR']
        }, component: CadastroIndicadorComponent
    },
    {
        path: 'atualizar-indicador/:id',
        canActivate: [AuthGuard], data: {
            roles: ['INDICADORES_OPERACIONAIS_VISUALIZAR', 'INDICADORES_OPERACIONAIS_ALTERAR']
        }, component: CadastroIndicadorComponent
    },
    {
        path: 'pesquisa-resultado-coleta',
        canActivate: [AuthGuard], data: {
            roles: ['RESULTADO_COLETAS_VISUALIZAR', 'RESULTADO_COLETAS_ALTERAR']
        }, component: PesquisaResultadoColetaComponent
    },
    {
        path: 'resultado-coleta',
        canActivate: [AuthGuard], data: {
            roles: ['RESULTADO_COLETAS_VISUALIZAR', 'RESULTADO_COLETAS_ALTERAR']
        }, component: ResultadoColetaComponent
    },
    {
        path: 'pesquisa-inconsistencia',
        canActivate: [AuthGuard], data: {
            roles: ['INCONSISTENCIAS_VISUALIZAR', 'INCONSISTENCIAS_ALTERAR']
        }, component: PesquisaInconsistenciasComponent
    },
    {
        path: 'resultado-inconsistencia',
        canActivate: [AuthGuard], data: {
            roles: ['INCONSISTENCIAS_VISUALIZAR', 'INCONSISTENCIAS_ALTERAR']
        }, component: ResultadoInconsistenciasComponent
    },
    {
        path: 'variaveis',
        canActivate: [AuthGuard], data: {
            roles: ['IMPORTACAO_VISUALIZAR', 'IMPORTACAO_ALTERAR']
        }, component: ConstrucaoVariaveisTabsetComponent
    },
    {
        path: 'listar-dados-transacionais',
        canActivate: [AuthGuard], data: {
            roles: ['IMPORTACAO_VISUALIZAR', 'IMPORTACAO_ALTERAR']
        }, component: ListarDadosTransacionaisComponent
    },
    {
        path: 'listar-variaveis',
        canActivate: [AuthGuard], data: {
            roles: ['IMPORTACAO_VISUALIZAR', 'IMPORTACAO_ALTERAR']
        }, component: ListarVariaveisComponent
    },
    {
        path: 'cadastro-dado-transacional',
        canActivate: [AuthGuard], data: {

            roles: ['IMPORTACAO_ALTERAR']
        }, component: CadastroDadoTransacionalComponent
    },
    {
        path: 'atualizar-dado-transacional/:id',
        canActivate: [AuthGuard], data: {
            roles: ['IMPORTACAO_VISUALIZAR', 'IMPORTACAO_ALTERAR']
        }, component: CadastroDadoTransacionalComponent
    },
    {
        path: 'construcao-variavel',
        canActivate: [AuthGuard], data: {
            roles: ['IMPORTACAO_VISUALIZAR', 'IMPORTACAO_ALTERAR']
        }, component: ConstrucaoVariavelComponent
    },
    {
        path: 'cadastro-dashboard',
        canActivate: [AuthGuard], data: {
            roles: ['DASHBOARDS_ALTERAR']
        }, component: CadastroDashboardComponent
    },
    {
        path: 'atualizar-dashboard/:id',
        canActivate: [AuthGuard], data: {
            roles: ['DASHBOARDS_VISUALIZAR', 'DASHBOARDS_ALTERAR']
        }, component: CadastroDashboardComponent
    },
    {
        path: 'visualizar-dashboard/:id',
        canActivate: [AuthGuard], data: {
            roles: ['DASHBOARDS_VISUALIZAR', 'DASHBOARDS_ALTERAR']
        }, component: VisualizarDashboardComponent
    },
    {
        path: 'listar-dashboards',
        canActivate: [AuthGuard], data: {
            roles: ['DASHBOARDS_VISUALIZAR', 'DASHBOARDS_ALTERAR']
        }, component: ListarDashboardsComponent
    },
    {
        path: 'pesquisar-reincidencia',
        canActivate: [AuthGuard], data: {
            roles: ['REINCIDENCIAS_VISUALIZAR',
                'REINCIDENCIAS_ALTERAR']
        }, component: PesquisaReincidenciaComponent
    },
    {
        path: 'listar-reincidencias',
        canActivate: [AuthGuard], data: {
            roles: ['REINCIDENCIAS_VISUALIZAR',
                'REINCIDENCIAS_ALTERAR']
        }, component: ListaReincidenciasComponent
    },
    {
        path: 'listar-roteiros-internos',
        canActivate: [AuthGuard], data: {
            roles: ['ROTEIRO_INTERNO_VISUALIZAR',
                'ROTEIRO_INTERNO_ALTERAR']
        }, component: ListarRoteiroInternoComponent
    },
    {
        path: 'roteiro-interno/:id',
        canActivate: [AuthGuard], data: {
            roles: ['ROTEIRO_INTERNO_VISUALIZAR',
                'ROTEIRO_INTERNO_ALTERAR']
        }, component: RoteiroInternoComponent
    },
];

export const routing: ModuleWithProviders = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotas.ts